import Swal from "sweetalert2";

export const showYesNoConfirm = async (title, text, icon, confirmButtonText, cancelButtonText) => {
    return await Swal.fire({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
    })
}